export class Vw_Stoklar {
    ID:number;
    Kodu:string;
    StokAdi:string;
    Barcode1:string;
    Barcode2:string;
    Vat:number;
    KategoriID:number;
    MarkId:number;
    VatGrupId:number;
    Price1:number;
    Price2:number;
    Price3:number;
    Price4:number;
    Status:number;
    WebStatus:number;
    BirimId:number;
    Image1:string;
    Image2:string;
    IsTerazi:number;
    PLU:number;
    FiyatDegisimTarihi:string;
    MaximumSeviye:number;
    MinumumSeviye:number;
    Hit:number;
    EkranSiraNo:number;
    Giren:number;
    Cikan:number;
    Kalan:number;
    KategoriAdi:string;
    BirimAdi:string;
    MarkaAdi:string;
    SatinAlmaTarihi:string;
    SatinAlmaGecenGun:number;
    SatisTarihi:string;
    SatisGecenGun:number;
    Entegrasyon:number;
    ParentAktif:number;
    Guncellendi:number;
    YerliMi:number;
    UlkeAdi:string;
    
}




// WEBPACK FOOTER //
// ./src/models/Vw_Stoklar.ts